import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, FontWeights, NeutralColors, Stack, Icon, SharedColors, Link, Text } from '@fluentui/react';
import { AppContext } from '../../../../context/context.esm.js';
import { imageMap } from '../../../../../data/images.esm.js';
import { useBreakpoint } from '@agoras/hooks';
import { useTranslation } from 'react-i18next';
import { useContext, useCallback } from 'react';
import { m365Products } from './constants.esm.js';
import logger from '@agoras/logger';
import { headerContext } from '../../../context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    textLink: {
        color: NeutralColors.gray160,
        fontWeight: FontWeights.semibold,
        marginRight: 8
    }
});
var iconStyles = {
    root: {
        color: NeutralColors.gray160,
        fontWeight: FontWeights.semibold,
        fontSize: 10
    }
};
var M365 = function(param) {
    var onLinkClick = param.onLinkClick;
    var _useBreakpoint = _sliced_to_array(useBreakpoint('xl'), 1), isXL = _useBreakpoint[0];
    var navigate = useContext(AppContext).navigate;
    var handleLinkClick = useCallback(function(navigateOptions) {
        navigate(navigateOptions);
        onLinkClick();
    }, [
        navigate,
        onLinkClick
    ]);
    var handleLogLink = useCallback(function(name) {
        logger.info(JSON.stringify({
            key: 'M365',
            name: name
        }), _object_spread({
            action: 'MegaMenu',
            actionModifier: 'Click link'
        }, headerContext));
    }, []);
    var handleSeeAllClick = useCallback(function() {
        handleLogLink('Explore all apps for Microsoft 365');
        navigate({
            type: 'App',
            query: {
                product: 'office'
            }
        });
        onLinkClick();
    }, [
        navigate,
        onLinkClick,
        handleLogLink
    ]);
    var handleSeeAllFreeAppsClick = useCallback(function() {
        handleLogLink('See all free apps');
        navigate({
            type: 'App',
            query: {
                filters: 'free',
                product: 'office'
            }
        });
        onLinkClick();
    }, [
        navigate,
        onLinkClick,
        handleLogLink
    ]);
    var handleSeeAllPaidAppsClick = useCallback(function() {
        handleLogLink('See all paid apps');
        navigate({
            type: 'App',
            query: {
                filters: 'pay-as-you-go',
                product: 'office'
            }
        });
        onLinkClick();
    }, [
        navigate,
        onLinkClick,
        handleLogLink
    ]);
    var t = useTranslation('header').t;
    return /*#__PURE__*/ jsxs(Stack, {
        tokens: {
            childrenGap: isXL ? 24 : 32
        },
        children: [
            /*#__PURE__*/ jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 20
                },
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        styles: {
                            root: {
                                fontSize: 20,
                                color: SharedColors.cyanBlue10
                            }
                        },
                        iconName: "AddIn"
                    }),
                    /*#__PURE__*/ jsxs(Stack, {
                        tokens: {
                            childrenGap: 4
                        },
                        children: [
                            /*#__PURE__*/ jsxs(Link, {
                                onClick: handleSeeAllClick,
                                children: [
                                    /*#__PURE__*/ jsx(Text, {
                                        className: classNames.textLink,
                                        children: t('Explore all apps for Microsoft 365')
                                    }),
                                    /*#__PURE__*/ jsx(Icon, {
                                        styles: iconStyles,
                                        iconName: "ChevronRightSmall"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs(Text, {
                                styles: {
                                    root: {
                                        color: NeutralColors.gray130
                                    }
                                },
                                children: [
                                    t('Find solutions for Microsoft products, like Outlook or Teams, to make them even more powerful.'),
                                    ' ',
                                    /*#__PURE__*/ jsx(Link, {
                                        onClick: handleSeeAllFreeAppsClick,
                                        children: t('See all free apps')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs(Text, {
                                styles: {
                                    root: {
                                        color: NeutralColors.gray130
                                    }
                                },
                                children: [
                                    t('Get the SaaS package which includes full capability versions of their related add-ins for Office and Teams.'),
                                    ' ',
                                    /*#__PURE__*/ jsx(Link, {
                                        onClick: handleSeeAllPaidAppsClick,
                                        children: t('See all paid apps')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Stack, {
                wrap: true,
                horizontal: true,
                styles: {
                    inner: {
                        rowGap: isXL ? '24px' : '32px',
                        columnGap: isXL ? '16px' : '32px'
                    }
                },
                children: m365Products.map(function(param) {
                    var title = param.title, description = param.description, icon = param.icon, navigateOptions = param.navigateOptions;
                    // const ProductIcon = imageMap[icon];
                    return /*#__PURE__*/ jsx(Stack.Item, {
                        basis: "calc((100% - ".concat(isXL ? 32 : 64, "px) * (1 / 3))"),
                        children: /*#__PURE__*/ jsxs(Stack, {
                            horizontal: true,
                            tokens: {
                                childrenGap: 20
                            },
                            children: [
                                /*#__PURE__*/ jsx(Stack.Item, {
                                    children: /*#__PURE__*/ jsx("img", {
                                        src: imageMap[icon],
                                        "aria-label": icon,
                                        width: "20",
                                        height: "20"
                                    })
                                }),
                                /*#__PURE__*/ jsxs(Stack, {
                                    tokens: {
                                        childrenGap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ jsxs(Link, {
                                            onClick: function() {
                                                handleLogLink(title);
                                                handleLinkClick(navigateOptions);
                                            },
                                            children: [
                                                /*#__PURE__*/ jsx(Text, {
                                                    className: classNames.textLink,
                                                    children: t(title)
                                                }),
                                                /*#__PURE__*/ jsx(Icon, {
                                                    styles: iconStyles,
                                                    iconName: "ChevronRightSmall"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ jsx(Text, {
                                            styles: {
                                                root: {
                                                    color: NeutralColors.gray130,
                                                    width: 'auto'
                                                }
                                            },
                                            children: t(description)
                                        })
                                    ]
                                })
                            ]
                        })
                    }, t(title));
                })
            })
        ]
    });
};

export { M365 as default };
